@use "variables" as *;

.header {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.breadcrumbs {
  margin-left: $spacing-xl !important;
}

.logo {
  height: 60px;
  width: 28%;
}

.logoImage {
  filter: drop-shadow(2px 2px 2px #222);
}

.mainDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  background-image: url(../../images/login_background.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.container {
  display: flex;
  width: 100%;
  flex-direction: row;
}

.options {
  width: 28%;
  flex-shrink: 0;
}

.mainContent {
  display: flex;
  flex-direction: column;
  padding: 0 $spacing-xl 0 $spacing-xl;
  overflow: auto;
}

.scrollReference {
  padding-bottom: $spacing-l;
}

.text {
  text-align: justify;
  text-justify: auto;
  font-size: $fontSize-m;
  white-space: pre-line;
}

h1,
h2 {
  text-align: start;
}

.footer {
  text-align: center;
  font-size: $fontSize-s;
  margin: $spacing-xxl $spacing-m $spacing-xl $spacing-m;
}

.creditsMobile {
  padding-bottom: $spacing-g;
}
